























































import { Component, Mixins, Prop } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { EDSConfig } from "~/eds.type";
import { NCALayerModes, TYPES_OF_STORAGE } from "@/config/consts";
import { SignService } from "@/services/sign.service";
import { translateSelectorItems } from "@/utils";

@Component({
  components: {},
})
export default class ECPSigner extends Mixins(FormValidator) {
  @Prop({ default: "Подписать с ЭЦП" })
  readonly title: string;

  showStorageTypeDialog: boolean = false;

  selectedStorageType = TYPES_OF_STORAGE[0].value;
  get storageTypes() {
    return translateSelectorItems.call(this, TYPES_OF_STORAGE);
  }

  resolvedPromise: any = null;
  dataToSign = {};
  options: EDSConfig | undefined;
  loading: boolean = false;

  async sign(data: any, options?: EDSConfig) {
    // defaults
    if (!options) {
      options = {
        signKey: "SIGNATURE",
        signMethod: "signXml" as NCALayerModes,
      };
    }
    // defaults
    if (options && !options.signKey) options.signKey = "SIGNATURE";
    // defaults
    if (options && !options.signMethod)
      options.signMethod = "signXml" as NCALayerModes;
    return new Promise((resolve) => {
      this.resolvedPromise = resolve;
      this.dataToSign = data;
      this.options = options;
      this.showStorageTypeDialog = true;
    });
  }

  errorMessage? = "";
  async signData() {    
    this.loading = true;
    const { result, message } = await SignService.signXML(
      this.selectedStorageType,
      this.dataToSign as string,
      this.options as EDSConfig,
    );
    this.errorMessage = message == "NCALayer: action.canceled" ? "" : message;
    this.resolvedPromise(result);
    this.loading = false;
    if (result) this.closeWindow();
  }
  closeWindow() {
    this.errorMessage = null as any;
    this.options = undefined;
    this.dataToSign = {};
    this.showStorageTypeDialog = false;
    this.resolvedPromise = undefined;
  }
}
